/** @jsx h */

import { Stage, Flex, Text, h } from "../comps";
import type { HeaderProps } from "./types";
import { directifyPadding } from "./utils";

export function summertime(props: HeaderProps) {
  const { sub, title, spacing, height, rtl } = props;

  return (
    <Stage width={700} height={height || 280}>
      <Flex padding={directifyPadding([70, 32, 70, 32], rtl)} justify="center" align="center" spacing={0 + (spacing || 0)}>
        <Text
          rtl={rtl}
          font={title.font}
          color={title.color}
          maxLines={2}
          limits={title.limits}
          letterSpacing={title.letterSpacing}
          lineHeight={title.lineHeight}
          align="center"
          fieldKey="title"
        >
          {title.text}
        </Text>
        {sub.text && (
          <Text
            rtl={rtl}
            color={sub.color}
            font={sub.font}
            maxLines={2}
            letterSpacing={sub.letterSpacing}
            lineHeight={sub.lineHeight}
            limits={sub.limits}
            align="center"
            fieldKey="subtitle"
          >
            {sub.text}
          </Text>
        )}
      </Flex>
    </Stage>
  ).toSVG();
}
